/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Hanly API v2
 * OpenAPI spec version: 0.0.1
 */

import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';
import {
  queryOptions as queryOptionsBuilder,
  useMutation,
  useQuery,
  useSuspenseQuery,
} from '@tanstack/react-query';
import type { ErrorType } from '../../custom-client';

import { customInstance } from '../../custom-client';
import type {
  Delivery,
  DeliveryCreateRequest,
  DetailError,
  PaginatedPurchaseOrder,
  PurchaseOrderDetail,
  PurchaseOrderListParams,
  StandardizedError,
} from '../hanlyAPIV2.schemas';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getPurchaseOrderDeliveryCreateUrl = () => {
  return '/api/v2/purchase-orders/deliveries';
};

/**
 * 指定した発注明細を入荷する。明細は同じ発注書のものに限る。入荷済みの明細・下書きの発注書の明細は入荷できない。
 * @summary 入荷を作成する
 */
export const purchaseOrderDeliveryCreate = async (
  deliveryCreateRequest: DeliveryCreateRequest,
  options?: Parameters<typeof customInstance>[1],
): Promise<Delivery> => {
  const getHeaders = (
    h?: NonNullable<RequestInit['headers']>,
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
  return customInstance<Delivery>(getPurchaseOrderDeliveryCreateUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(deliveryCreateRequest),
  });
};

export const getPurchaseOrderDeliveryCreateMutationKey = () => ['purchaseOrderDeliveryCreate'] as const;

export const getPurchaseOrderDeliveryCreateMutationOptions = <
  TError = ErrorType<StandardizedError | DetailError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof purchaseOrderDeliveryCreate>>,
    TError,
    PurchaseOrderDeliveryCreateMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof purchaseOrderDeliveryCreate>>,
  TError,
  PurchaseOrderDeliveryCreateMutationVariables,
  TContext
> => {
  const mutationKey = getPurchaseOrderDeliveryCreateMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof purchaseOrderDeliveryCreate>>,
    PurchaseOrderDeliveryCreateMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return purchaseOrderDeliveryCreate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PurchaseOrderDeliveryCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof purchaseOrderDeliveryCreate>>
>;
export type PurchaseOrderDeliveryCreateMutationBody = DeliveryCreateRequest;
export type PurchaseOrderDeliveryCreateMutationError = ErrorType<StandardizedError | DetailError>;
export type PurchaseOrderDeliveryCreateMutationVariables = { data: DeliveryCreateRequest };

/**
 * @summary 入荷を作成する
 */
export const usePurchaseOrderDeliveryCreate = <
  TError = ErrorType<StandardizedError | DetailError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof purchaseOrderDeliveryCreate>>,
      TError,
      PurchaseOrderDeliveryCreateMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof purchaseOrderDeliveryCreate>>,
  TError,
  PurchaseOrderDeliveryCreateMutationVariables,
  TContext
> => {
  return useMutation(getPurchaseOrderDeliveryCreateMutationOptions(options), queryClient);
};
export const getPurchaseOrderListUrl = (params?: PurchaseOrderListParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/v2/purchase-orders/orders?${stringifiedParams}`
    : '/api/v2/purchase-orders/orders';
};

/**
 * カスタム項目は custom_property_{N}(N は項目の property_type)で検索できる(項目の種別により完全一致または部分一致)。
 * @summary 発注書一覧を返す
 */
export const purchaseOrderList = async (
  params?: PurchaseOrderListParams,
  options?: Parameters<typeof customInstance>[1],
): Promise<PaginatedPurchaseOrder> => {
  return customInstance<PaginatedPurchaseOrder>(getPurchaseOrderListUrl(params), {
    ...options,
    method: 'GET',
  });
};

export const getPurchaseOrderListQueryKey = (params?: PurchaseOrderListParams) => {
  return ['/api/v2/purchase-orders/orders', ...(params ? [params] : [])] as const;
};

export const getPurchaseOrderListQueryOptions = <
  TData = Awaited<ReturnType<typeof purchaseOrderList>>,
  TError = ErrorType<StandardizedError | DetailError>,
>(
  params?: PurchaseOrderListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof purchaseOrderList>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getPurchaseOrderListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof purchaseOrderList>>> = ({ signal }) =>
    purchaseOrderList(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof purchaseOrderList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type PurchaseOrderListQueryResult = NonNullable<Awaited<ReturnType<typeof purchaseOrderList>>>;
export type PurchaseOrderListQueryError = ErrorType<StandardizedError | DetailError>;

export function usePurchaseOrderList<
  TData = Awaited<ReturnType<typeof purchaseOrderList>>,
  TError = ErrorType<StandardizedError | DetailError>,
>(
  params: undefined | PurchaseOrderListParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof purchaseOrderList>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof purchaseOrderList>>,
          TError,
          Awaited<ReturnType<typeof purchaseOrderList>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePurchaseOrderList<
  TData = Awaited<ReturnType<typeof purchaseOrderList>>,
  TError = ErrorType<StandardizedError | DetailError>,
>(
  params?: PurchaseOrderListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof purchaseOrderList>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof purchaseOrderList>>,
          TError,
          Awaited<ReturnType<typeof purchaseOrderList>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePurchaseOrderList<
  TData = Awaited<ReturnType<typeof purchaseOrderList>>,
  TError = ErrorType<StandardizedError | DetailError>,
>(
  params?: PurchaseOrderListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof purchaseOrderList>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary 発注書一覧を返す
 */

export function usePurchaseOrderList<
  TData = Awaited<ReturnType<typeof purchaseOrderList>>,
  TError = ErrorType<StandardizedError | DetailError>,
>(
  params?: PurchaseOrderListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof purchaseOrderList>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getPurchaseOrderListQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getPurchaseOrderListSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof purchaseOrderList>>,
  TError = ErrorType<StandardizedError | DetailError>,
>(
  params?: PurchaseOrderListParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof purchaseOrderList>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getPurchaseOrderListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof purchaseOrderList>>> = ({ signal }) =>
    purchaseOrderList(params, { signal, ...requestOptions });

  return queryOptionsBuilder({
    queryKey,
    ...queryOptions,
    queryFn: queryOptions?.queryFn ?? queryFn,
  }) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof purchaseOrderList>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } };
};

export type PurchaseOrderListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof purchaseOrderList>>>;
export type PurchaseOrderListSuspenseQueryError = ErrorType<StandardizedError | DetailError>;

export function usePurchaseOrderListSuspense<
  TData = Awaited<ReturnType<typeof purchaseOrderList>>,
  TError = ErrorType<StandardizedError | DetailError>,
>(
  params: undefined | PurchaseOrderListParams,
  options: {
    query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof purchaseOrderList>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePurchaseOrderListSuspense<
  TData = Awaited<ReturnType<typeof purchaseOrderList>>,
  TError = ErrorType<StandardizedError | DetailError>,
>(
  params?: PurchaseOrderListParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof purchaseOrderList>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePurchaseOrderListSuspense<
  TData = Awaited<ReturnType<typeof purchaseOrderList>>,
  TError = ErrorType<StandardizedError | DetailError>,
>(
  params?: PurchaseOrderListParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof purchaseOrderList>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary 発注書一覧を返す
 */

export function usePurchaseOrderListSuspense<
  TData = Awaited<ReturnType<typeof purchaseOrderList>>,
  TError = ErrorType<StandardizedError | DetailError>,
>(
  params?: PurchaseOrderListParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof purchaseOrderList>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getPurchaseOrderListSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getPurchaseOrderDetailUrl = (id: number) => {
  return `/api/v2/purchase-orders/orders/${id}`;
};

/**
 * @summary 発注書の詳細を取得する
 */
export const purchaseOrderDetail = async (
  id: number,
  options?: Parameters<typeof customInstance>[1],
): Promise<PurchaseOrderDetail> => {
  return customInstance<PurchaseOrderDetail>(getPurchaseOrderDetailUrl(id), {
    ...options,
    method: 'GET',
  });
};

export const getPurchaseOrderDetailQueryKey = (id: number) => {
  return [`/api/v2/purchase-orders/orders/${id}`] as const;
};

export const getPurchaseOrderDetailQueryOptions = <
  TData = Awaited<ReturnType<typeof purchaseOrderDetail>>,
  TError = ErrorType<StandardizedError | DetailError>,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof purchaseOrderDetail>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getPurchaseOrderDetailQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof purchaseOrderDetail>>> = ({ signal }) =>
    purchaseOrderDetail(id, { signal, ...requestOptions });

  return { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof purchaseOrderDetail>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type PurchaseOrderDetailQueryResult = NonNullable<Awaited<ReturnType<typeof purchaseOrderDetail>>>;
export type PurchaseOrderDetailQueryError = ErrorType<StandardizedError | DetailError>;

export function usePurchaseOrderDetail<
  TData = Awaited<ReturnType<typeof purchaseOrderDetail>>,
  TError = ErrorType<StandardizedError | DetailError>,
>(
  id: number,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof purchaseOrderDetail>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof purchaseOrderDetail>>,
          TError,
          Awaited<ReturnType<typeof purchaseOrderDetail>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePurchaseOrderDetail<
  TData = Awaited<ReturnType<typeof purchaseOrderDetail>>,
  TError = ErrorType<StandardizedError | DetailError>,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof purchaseOrderDetail>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof purchaseOrderDetail>>,
          TError,
          Awaited<ReturnType<typeof purchaseOrderDetail>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePurchaseOrderDetail<
  TData = Awaited<ReturnType<typeof purchaseOrderDetail>>,
  TError = ErrorType<StandardizedError | DetailError>,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof purchaseOrderDetail>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary 発注書の詳細を取得する
 */

export function usePurchaseOrderDetail<
  TData = Awaited<ReturnType<typeof purchaseOrderDetail>>,
  TError = ErrorType<StandardizedError | DetailError>,
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof purchaseOrderDetail>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getPurchaseOrderDetailQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getPurchaseOrderDetailSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof purchaseOrderDetail>>,
  TError = ErrorType<StandardizedError | DetailError>,
>(
  id: number,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof purchaseOrderDetail>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getPurchaseOrderDetailQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof purchaseOrderDetail>>> = ({ signal }) =>
    purchaseOrderDetail(id, { signal, ...requestOptions });

  return queryOptionsBuilder({
    queryKey,
    ...queryOptions,
    queryFn: queryOptions?.queryFn ?? queryFn,
  }) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof purchaseOrderDetail>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } };
};

export type PurchaseOrderDetailSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof purchaseOrderDetail>>
>;
export type PurchaseOrderDetailSuspenseQueryError = ErrorType<StandardizedError | DetailError>;

export function usePurchaseOrderDetailSuspense<
  TData = Awaited<ReturnType<typeof purchaseOrderDetail>>,
  TError = ErrorType<StandardizedError | DetailError>,
>(
  id: number,
  options: {
    query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof purchaseOrderDetail>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePurchaseOrderDetailSuspense<
  TData = Awaited<ReturnType<typeof purchaseOrderDetail>>,
  TError = ErrorType<StandardizedError | DetailError>,
>(
  id: number,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof purchaseOrderDetail>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePurchaseOrderDetailSuspense<
  TData = Awaited<ReturnType<typeof purchaseOrderDetail>>,
  TError = ErrorType<StandardizedError | DetailError>,
>(
  id: number,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof purchaseOrderDetail>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary 発注書の詳細を取得する
 */

export function usePurchaseOrderDetailSuspense<
  TData = Awaited<ReturnType<typeof purchaseOrderDetail>>,
  TError = ErrorType<StandardizedError | DetailError>,
>(
  id: number,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof purchaseOrderDetail>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getPurchaseOrderDetailSuspenseQueryOptions(id, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}
